module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question"
  }, [(_vm.questionData) ? [_c('p', {
    staticClass: "question__name"
  }, [_vm._v(_vm._s(_vm.questionData.name))]), _vm._v(" "), _c('img', {
    staticClass: "question__img",
    attrs: {
      "src": ("http://transfertsdepekin.fr/assets/places/" + (_vm.questionData.placeImg)),
      "alt": _vm.questionData.name
    },
    on: {
      "click": _vm.setPopinState
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "question__btn btn",
    on: {
      "click": _vm.setPopinState
    }
  }, [(_vm.questionData.type === 'chance') ? [_vm._v("Chance")] : [_vm._v("Question")]], 2), _vm._v(" "), _vm._m(0)] : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question__stars"
  }, [_c('img', {
    attrs: {
      "src": require("@/img/star_white.png"),
      "alt": "Star"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/img/star_orange.png"),
      "alt": "Star"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/img/star_orange.png"),
      "alt": "Star"
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("@/img/star_white.png"),
      "alt": "Star"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52372aca"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/game/Question.vue
// module id = 85
// module chunks = 0